enum MessageTypes {
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

export default MessageTypes
